import { render, staticRenderFns } from "./VideoIndex.vue?vue&type=template&id=2b09e0dc&scoped=true"
import script from "./VideoIndex.vue?vue&type=script&lang=js"
export * from "./VideoIndex.vue?vue&type=script&lang=js"
import style0 from "./VideoIndex.vue?vue&type=style&index=0&id=2b09e0dc&prod&scoped=true&lang=css"
import style1 from "./VideoIndex.vue?vue&type=style&index=1&id=2b09e0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09e0dc",
  null
  
)

export default component.exports